// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FCM_API_KEY,
  authDomain: process.env.VUE_APP_FCM_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FCM_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FCM_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FCM_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// ブラウザが対応しているか確認してからMessagingインスタンスを取得
const messaging = getMessaging(app);

export { app, messaging };
